<template>
  <div class="page-grid-fix negative-colors" style="padding-bottom: 85px;">
    <article class="negative-colors grid-container columns-three-two-rows shadow regular-gap">
      <!-- Loop through Instagram posts and display them in a grid -->
      <div v-if="instagramPosts.length" class="instagram-grid">
        <div v-for="(post, index) in instagramPosts" :key="index" class="instagram-item">
          <img :src="post.media_url" alt="Instagram post" />
        </div>
      </div>
      <div v-else>
        <p>Loading Instagram feed...</p>
      </div>
    </article>

    <!-- Space helper and styling -->
    <div class="space-helper"></div>
    <div class="separator"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      instagramPosts: [],
      accessToken: 'YOUR_ACCESS_TOKEN',  // Replace with your Instagram token
      userId: 'ninetywatchesandjewellery', // Replace with your Instagram User ID
    };
  },
  mounted() {
    this.fetchInstagramFeed();
  },
  methods: {
    async fetchInstagramFeed() {
      try {
        // Instagram API endpoint to fetch media
        const apiUrl = `https://graph.instagram.com/${this.userId}/media?fields=id,media_type,media_url,thumbnail_url,caption&access_token=${this.accessToken}&limit=12`;
        const response = await fetch(apiUrl);
        const data = await response.json();

        // Handle the response and store the posts
        if (data.data) {
          this.instagramPosts = data.data;
        }
      } catch (error) {
        console.error("Error fetching Instagram feed:", error);
      }
    }
  }
};
</script>

<style scoped>
.instagram-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Adjust grid columns */
  gap: 16px;
}

.instagram-item img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.separator {
  display: block;
  position: absolute;
  height: 85px;
  width: 50%;
  border-right: 1px solid black;
  left: 0;
}
</style>